module.exports = __webpack_public_path__ + "img/live05.5eb909cf.png";